/**
 * API Configuration
 * Loads API URLs from environment variables (.env file)
 * 
 * Environment variables:
 * - REACT_APP_API_URL: Base API URL (e.g., http://localhost:3000)
 */

const getApiConfig = () => {
  // Get base API URL from environment variable
  // Remove trailing slashes and return clean URL
  const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:3000')
    .replace(/\/+$/, '');
  
  // Return base URL and full API URL
  return {
    baseUrl,
    apiUrl: `${baseUrl}/api`,
  };
};

// Export singleton config
const config = getApiConfig();

export default config;
export const getApiBaseUrl = () => config.baseUrl;
export const getApiUrl = () => config.apiUrl;

